exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2izCF{font-size:14px;line-height:17px;color:#000;margin-bottom:5px}._3TQ81{font-weight:700;padding:5px;border-radius:2px;color:#000;font-weight:600;font-size:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:111px;background:#ffd906}", ""]);

// exports
exports.locals = {
	"small": "_2izCF",
	"yellow": "_3TQ81"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/PriceUah/PriceUah.css
// module id = 1714
// module chunks = 15 20 21 23 32 33 38